import { FC } from 'react';

// MUI
import TextField, { TextFieldProps } from '@mui/material/TextField';

// Third party
import { Controller, useFormContext } from 'react-hook-form';

type TRHFTextField = TextFieldProps & {
  name: string;
};

const RHFTextField: FC<TRHFTextField> = ({
  name, helperText, type, placeholder, label, autoComplete = 'off', sx, ...other
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          autoComplete={autoComplete}
          slotProps={{
            input: {
              autoComplete: autoComplete,
              inputProps: { maxLength: 225 },
            }
          }}
          sx={sx}
          label={label}
          placeholder={placeholder}
          {...field}
          fullWidth
          type={type}
          value={type === 'number' && field.value === 0 ? '': field.value}
          onChange={(event) => {
            if (type === 'number') {
              field.onChange(Number(event.target.value));
            } else if (type === 'tel') {
              const sanitized = event.target.value.replace(/[^0-9+\-() ]/g, '');
              field.onChange(sanitized);
            } else {
              field.onChange(event.target.value);
            }
          }}
          error={!!error}
          helperText={error ? error?.message: helperText}
          {...other}
        />
      )}
    />
  );
};

export {
  RHFTextField,
};
